import { globalCss, styled } from ".";

export const globalStyles = globalCss({
  ".tiptap": {
    p: {
      fontSize: "12px",
    },
    h1: {
      fontSize: "5rem",
      lineHeight: "5rem",
    },
    h2: {
      fontSize: "30px",
    },
    u: {
      textDecoration: "underline",
    },
    s: {
      textDecoration: "line-through",
    },
  },
  "krv-editor": {
    alignItems: "center",
  },
  "*": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    outline: "unset",
    "-webkit-text-size-adjust": "none",
    "text-decoration-style": "unset",
    "text-decoration": "unset",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale",
  },

  html: {
    overflowY: "hidden",
  },
  body: {
    position: "fixed",
    width: "100%",
    height: "100dvh",
    fontFamily: "Inter",

    "@sm": {
      height: "100%",
      maxHeight: "-webkit-fill-available",
    },
  },

  "h1, h2, h3, h4, h5, h6, header, thead, th": {
    fontFamily: "Satoshi !important",
  },

  button: {
    fontFamily: "Satoshi !important",
    "*": {
      fontFamily: "Satoshi !important",
    },
  },

  "p, span, li, div, label, strong, b, a, input, textarea, select, option, optgroup, option": {
    fontFamily: "Inter !important",
  },

  "::-webkit-scrollbar": {
    width: "7px",
    height: "7px",
  },

  "::-webkit-scrollbar-thumb": {
    background: "$neutral70",
    borderRadius: "$md",
  },

  "::-webkit-scrollbar-track": {
    backgroundColor: "$neutral20",
    borderRadius: "4px",
  },

  "#modal-app, #menu-bottom": {
    zIndex: "999",
  },

  ".intercom-lightweight-app": {
    zIndex: "40 !important",
  },

  "@sm": {
    ".intercom-launcher": {
      bottom: "85px !important",
    },

    ".intercom-lightweight-app-launcher": {
      bottom: "85px !important",
    },

    ".intercom-dfosxs": {
      bottom: "85px !important",
    },

    " iframe[name='intercom-notifications-frame']": {
      bottom: "124px !important",
    },
  },

  ".ReactCollapse--collapse": {
    transition: "height 150ms",
  },

  "#nprogress .bar": {
    background: "#021327",
    height: "5px",
  },

  "#nprogress .peg": {
    boxShadow: "0 0 10px #021327, 0 0 5px #021327",
  },

  ".rs-picker-menu, .rs-picker-popup": {
    zIndex: "9999 !important",
  },

  ".rs-picker-toggle-value": {
    fontFamily: "$inter !important",
    color: "$neutral80 !important",
  },

  ".react-date-picker__wrapper": {
    flexFlow: "row-reverse !important",
  },

  ".react-calendar": {
    "*": {
      fontFamily: "$inter !important",
    },

    borderRadius: "$md",
  },

  "body.remove-intercom-icon": {
    ".intercom-lightweight-app": {
      display: "none !important",
      visibility: "hidden !important",
      opacity: "0 !important",
      pointerEvents: "none !important",
    },
    "#intercom-container": {
      display: "none !important",
      visibility: "hidden !important",
      opacity: "0 !important",
      pointerEvents: "none !important",
    },
    ".intercom-launcher": {
      display: "none !important",
      visibility: "hidden !important",
      opacity: "0 !important",
      pointerEvents: "none !important",
    },
  },
});

export const FormWrapper = styled("form", {
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

export const FlexContainer = styled("div", {
  display: "flex",
  width: "100%",
  variants: {
    flexDirection: {
      row: {
        flexDirection: "row",
      },
      column: {
        flexDirection: "column",
      },
    },

    alignItems: {
      center: {
        alignItems: "center",
      },
      start: {
        alignItems: "flex-start",
      },
    },

    justifyContent: {
      center: {
        justifyContent: "center",
      },
      start: {
        justifyContent: "flex-start",
      },
      between: {
        justifyContent: "space-between",
      },
    },

    nowrap: {
      true: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      false: {
        whiteSpace: "unset",
        overflow: "unset",
        textOverflow: "unset",
        flexWrap: "wrap",
      },
    },

    gap: {
      2: {
        gap: "$2px",
      },
      4: {
        gap: "$4px",
      },
      6: {
        gap: "$6px",
      },
      8: {
        gap: "$8px",
      },
      10: {
        gap: "$10px",
      },
      12: {
        gap: "$12px",
      },
      16: {
        gap: "$16px",
      },
      20: {
        gap: "$20px",
      },
      24: {
        gap: "$24px",
      },
      32: {
        gap: "$32px",
      },
      xl: {
        gap: "$40px",
      },
    },

    width: {
      full: {
        width: "100%",
      },
      max: {
        width: "max-content",
      },
    },
  },

  defaultVariants: {
    flexDirection: "row",
  },
});

export const FlexRow = styled("div", {
  display: "flex",
  flexDirection: "row",
  variants: {
    fullWidth: {
      true: {
        width: "100%",
      },
    },
  },
});

export const FlexColumn = styled("div", {
  display: "flex",
  flexDirection: "column",
  variants: {
    fullWidth: {
      true: {
        width: "100%",
      },
    },
  },
});

export const CenteredContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});
